<script>
import {defineComponent} from 'vue'
import {CommonMixin} from "@/mixins/commonMethods";
import {mapMutations} from "vuex";

export default defineComponent({
    name: "mini-cart",
    mixins: [CommonMixin],
    props: {
        icnHeight: {
            type: String,
            required: true
        },
        cart: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data: () => ({
        cartItemsWithImages: [],
        hoverElement: ''
    }),
    methods: {
        setCartBlock() {
            this.$nextTick(() => {
                this.$refs["cart-block"].style.top = parseInt(this.icnHeight) * 1.35 + 'px';
            })
        },
        getItemImages(code) {
            const fetchParams = { productCode: code };
            return this.$store.dispatch('fetchImages', fetchParams)
                .then(() => this.$store.state.images.filter(img => img['Тип'] === 'Заглавная'))
                .catch(err => console.error("Error fetching images:", err));
        },
        closeCart() {
            this.$emit('close-cart');
        },
        ...mapMutations(['REMOVE_FROM_CART']),
        removeFromCart(item) {
            this.REMOVE_FROM_CART({ item: item });
        }
    },
    async mounted() {
        this.setCartBlock()
    },
    watch: {
        'cart.items.length': {
            async handler(oldValue, newValue) {
                if (newValue !== oldValue) {
                    this.cartItemsWithImages = []
                    if (this.cart.items) {
                        for (let item of this.cart.items) {
                            const images = await this.getItemImages(item['Код']);
                            if (images?.length > 0) {
                                item['Ссылка'] = images[0]['Ссылка']; // Добавляем ссылку первой заглавной картинки прямо в товар
                            }
                            this.cartItemsWithImages.push(item); // Сохраняем обновленный элемент товара
                        }
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
})
</script>

<template>
    <div class="cart-block" ref="cart-block">
        <div class="cart-header">
            <div class="left">
                <h4>Корзина</h4>
                <span v-if="cart.totalQuantity > 0">{{ cart.totalQuantity }}</span>
            </div>
            <div class="right">
                <p @click="closeCart()">[закрыть]</p>
            </div>
        </div>
        <div class="hr"></div>
        <div class="cart-elems-container">
            <div class="cart-elems" v-if="cart.totalQuantity > 0">
                <div v-for="item of cartItemsWithImages">
                    <div class="cart-item" v-if="item['Код'] != 'Shipping'" @mouseover="hoverElement = item" @mouseout="hoverElement = ''">
                        <div class="item-img" :style="'background: url(' + setImageThumbURL(item) + ')'">
                        </div>
                        <div class="item-text">
                            <p class="item-header">{{ item["Название продукта"] }}</p>
                            <p class="item-code">Артикул: {{ item["Код"] }}</p>
                        </div>

                        <div :class="['item-delete', hoverElement===item ? 'active' : '']" @click="removeFromCart(item)">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 19V12H2V5.2793L4.37109 4.48926L5.00391 6.38574L4 6.71973V10H7V19H19C19 19.5304 18.7891 20.039 18.4141 20.4141C18.039 20.7891 17.5304 21 17 21H7C6.46957 21 5.96101 20.7891 5.58594 20.4141C5.21086 20.039 5 19.5304 5 19ZM10 4C10 4.53043 10.2109 5.03899 10.5859 5.41406C10.961 5.78913 11.4696 6 12 6C12.5304 6 13.039 5.78913 13.4141 5.41406C13.7891 5.03899 14 4.53043 14 4V2.6123L22 5.2793V12H19V14.168H17V10H20V6.71973L15.7773 5.3125C15.581 5.87763 15.2592 6.39704 14.8281 6.82812C14.078 7.57827 13.0609 8 12 8C10.9391 8 9.45003 6.63372 9.45003 6.63372C9.45003 6.63372 9.45003 6.63372 8.22363 5.31738L8.17578 5.33398L7.53516 3.43945L10 2.60645V4Z" fill="black"/>
                                <path d="M8.15137 5.24902L6.68555 3.77539L7.57715 3.47754L8.15137 5.24902Z" fill="black" stroke="black" stroke-width="0.1"/>
                                <path d="M2 3.41504L21 22.415" id="del-line" stroke="black" stroke-width="2"/>
                                <path d="M18.9502 14.0537V16.0459L18.6543 15.7393L18.6533 15.7383L17.0498 14.1465V14.0537H18.9502Z" fill="black" stroke="black" stroke-width="0.1"/>
                            </svg>
                            <span>Удалить</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cart-no-elems" v-else>

            </div>
        </div>
        <div class="hr"></div>
        <router-link to="/checkout" class="to-checkout">
            <p>Оформить заказ</p>
        </router-link>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .cart-block {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: -10px;
        top: 0;
        height: 450px;
        width: 300px;
        background: rgba(255, 255, 255, 0.5);
        z-index: 5;
        -webkit-backdrop-filter: blur(7px);
        backdrop-filter: blur(7px);
        box-shadow: $shadow;
        //border-radius: 15px;
        border: 1px solid $gray;
        transition: $transition;
        padding: 20px;
        box-sizing: border-box;
    }

    .cart-header {
        padding: 0 1%;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: space-between;
    }

    .cart-header .left {
        display: flex;
        flex-direction: row;
        align-content: center;
    }

    .cart-header .right p {
        font-size: 12px;
        color: $black;
        cursor: pointer;
    }

    .cart-header h4 {
        font-weight: 500;
        font-size: 22px;
        margin-right: 4%;
    }

    .cart-header span {
        color: $purple
    }

    .hr {
        margin: 4% 0;
    }

    .cart-elems-container {
        flex-grow: 1;
        overflow-y: scroll;
    }

    .to-checkout {
        background: $black;
        padding: 4%;
        display: flex;
        align-content: center;
        justify-content: center;
    }

    .to-checkout p {
        color: white;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 500;
    }

    .cart-elems {
        display: flex;
        flex-direction: column;
        gap: 7px;
    }

    .cart-elems > div {
        position: relative;
    }

    .cart-item {
        display: flex;
        flex-direction: row;
        align-items: center;

        gap: 6%;
        background: rgba(255, 255, 255, 0.7);
        border: 1px solid $gray;

        box-sizing: border-box;
    }

    .item-img {
        border: 1px solid $light-gray;
        min-width: 60px;
        min-height: 60px;
        height: 60px;
        width: 60px;
        background-size: cover !important;
        background-position: center !important;
        background-repeat: no-repeat !important;

        position: relative;
    }

    .delete-item-icon {
        position: absolute;
        bottom: 5%;
        right: 0;
    }

    .item-text {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding-right: 7px;
    }

    .item-code {
        color: $hard-gray;
        font-size: 9px;
    }

    .item-header {
        font-size: 14px;
        font-weight: 500;
    }

    .item-delete {
        height: 100%;
        width: 0;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        transition: $transition;
        transition-property: width;

        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        box-sizing: border-box;

        cursor: not-allowed;
    }

    .item-delete * {
        opacity: 0;
        transition: $transition;

        fill: $purple;
        color: $purple;
    }

    .item-delete #del-line {
        stroke: $purple;
    }

    .item-delete span {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.5px;
        text-transform: uppercase;
    }

    .item-delete.active {
        width: 100%;
        border: 2px solid $black;
    }

    .item-delete.active * {
        opacity: 1;
        fill: $white;
        color: $white;
    }

    .item-delete.active #del-line {
        stroke: $white;
    }
</style>